import { internalUrls } from './config.internalUrls';

const domain = document.domain;

const tprecmApiUrls = internalUrls.includes(domain) ?
   {

      'LOCAL': 'http://localhost.gm.com:8081/',
      'DEV': 'https://mesc-service-dev.musea2.azure.ext.gm.com/tprecm-service/',
      'QA': 'https://tprecm-service-api-ocf-qa.apps.pcfepgstg1mi.gm.com/',
      'TEST': 'https://tprecm-service-api-ocf-test.apps.pcfepgstg1mi.gm.com/',
      'PROD': 'https://mesc-service.musea2.azure.ext.gm.com/tprecm-service/',

   } :
   {
      'DEV': 'https://mesc-service-dev.musea2.azure.ext.gm.com/tprecm-service/',
      'TEST': 'https://mfg-gateway-test.op-epg1mi.gm.com/tprecm/api/',
      'QA': 'https://mfg-gateway-qa.op-epg1mi.gm.com/tprecm/api/',
      'PROD': 'https://mesc-service.musea2.azure.ext.gm.com/tprecm-service/'
   };

/**
 *
 */
export const mescUrl = {

   'LOCAL': 'http://localhost.gm.com/',
   'DEV': 'https://mesc-dev.musea2.azure.ext.gm.com/',
   'QA': 'https://mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com/',
   'TEST': 'https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com/',
   'PROD': 'https://mesc.musea2.azure.ext.gm.com/',

};

export const tprecmConfig = {
   tprecmApiBaseUrl: tprecmApiUrls,
};



